import axios from 'axios';
import { API_BASE_URL } from './urls';

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds timeout
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - runs before each request
axiosInstance.interceptors.request.use(
  (config) => {
    // List of endpoints that should NOT have the admin token
    const noAuthEndpoints = ['/esignet/token', '/esignet/saveUser'];
    
    // Check if this request is to an OAuth endpoint
    const isOAuthEndpoint = noAuthEndpoints.some(endpoint => 
      config.url.includes(endpoint)
    );
    
    // Only add admin token for non-OAuth endpoints
    if (!isOAuthEndpoint) {
      const token = sessionStorage.getItem('adminToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    console.log('Request:', config.method.toUpperCase(), config.url);
    return config; // FIX: Added missing return statement
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - runs after each response
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Response:', response.status, response.config.url);
    return response; // FIX: Added missing return statement
  },
  (error) => {
    // Handle common errors
    if (error.response) {
      // Server responded with error status
      const isOAuthEndpoint = error.config?.url?.includes('/esignet/');
      
      // Only log non-OAuth errors to avoid confusion
      if (!isOAuthEndpoint) {
        console.error('Response error:', error.response.status, error.response.data);
      }
      
      // Handle unauthorized access (but not for OAuth endpoints)
      if (error.response.status === 401 && !isOAuthEndpoint) {
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminTokenExpiry');
        // Optionally redirect to login
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error('No response received:', error.request);
    } else {
      const url = error.config?.url || 'unknown URL';
      console.error('Request setup error:', error.message, 'for URL:', url);
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;